import { Stack, Typography } from '@mui/material';

import { translate } from '@/ui/i18n';

import { AddTourEventsButtonAndModal } from './AddTourEventsButtonAndModal';

export function TourTraveListBodyEmpty({ sequenceId }: { sequenceId: number }) {
  return (
    <Stack
      sx={{ my: 5, gap: 2, flexDirection: 'column', alignItems: 'center' }}
    >
      <Typography sx={{ fontSize: '1rem' }}>
        {translate('ProjectsTour.OnTour.no-date-message')}
      </Typography>
      <AddTourEventsButtonAndModal sequenceId={sequenceId} />
    </Stack>
  );
}
